import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { identifyUser } from 'lib/hotjar';
import { setUser } from 'utils/datadog';
import { selectCompany, selectUac, selectUserDetails } from 'store/common/selectors/profile';

/**
 * Attaches the user's access code to the session-recording and RUM tools once the profile
 * lands. `uac` is undefined until the profile query resolves, so this keys off its arrival
 * rather than running on mount.
 */
export function useAnalyticsIdentity() {
    const uac = useSelector(selectUac);
    const userDetails = useSelector(selectUserDetails);
    const company = useSelector(selectCompany);

    const companyUUID = company?.uuid;
    const companyName = company?.name;

    useEffect(() => {
        if (!uac) return;

        const firstName = userDetails?.first_name;

        identifyUser(uac, { companyUUID, firstName, companyName });

        setUser({
            uuid: uac,
            first_name: firstName,
            last_name: userDetails?.last_name,
            company_name: companyName,
            company_id: companyUUID,
        });
    }, [uac, userDetails?.first_name, userDetails?.last_name, companyUUID, companyName]);
}

export default useAnalyticsIdentity;
